const ArchParts2500 = (index, nodes, materials, metal, first, last, archAntiHotSpotTape, antiHotSpotTape, zigzag, cropSupportBar) => {
  let partsToShow = []

  if(archAntiHotSpotTape) {
    partsToShow.push(
      <mesh key="ANTI-HOT-TAPE001" geometry={nodes['ANTI-HOT-TAPE001'].geometry} material={materials.tape} position={[-2.5, 0, 0]} scale={1.001}/>
    )
  }
      
  if(first || last) {
    partsToShow.push(
      <group key={`2500-arch-parts-${index}`}>
        <group name='BRACE-BAR'>
          <group position={last ? [-2.507, -1.967, -0.33] : [0.007, 1.969, -0.33]} rotation={last ? [0.902, -0.121, -1.312] : [-0.902, 0.121, 1.83]}>
            <mesh name="PART_R32-2210-BRACE_BAR_LEFT" geometry={nodes['PART_R32-2210-BRACE_BAR_LEFT'].geometry} >
              {metal}
            </mesh>
            <mesh name="32mm_Brace_Bracket002" geometry={nodes['32mm_Brace_Bracket002'].geometry} position={[0.012, 0.008, 0.031]} rotation={[1.445, -0.257, -2.272]}>
              {metal}
              {/* <mesh name="Mesh_1007_1" geometry={nodes.Mesh_1007_1.geometry} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2008_1" geometry={nodes.Mesh_2008_1.geometry} position={[0.032, 0.012, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3008_1" geometry={nodes.Mesh_3008_1.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4010" geometry={nodes.Mesh_4010.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            <mesh name="32mm_Brace_Bracket003" geometry={nodes['32mm_Brace_Bracket003'].geometry} position={[-0.017, 0.001, -2.514]} rotation={[1.908, 0.302, 0.858]}>
              {metal}
              {/* <mesh name="Mesh_1008_1" geometry={nodes.Mesh_1008_1.geometry} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2009_1" geometry={nodes.Mesh_2009_1.geometry} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3009" geometry={nodes.Mesh_3009_1.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4011" geometry={nodes.Mesh_4011.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            {
              antiHotSpotTape &&
                <mesh name="ANTI-HOT-TAPE004" geometry={nodes['ANTI-HOT-TAPE004'].geometry} material={materials.tape} scale={1.001}/>
            }
          </group>
          <group position={last ? [0.007, -1.967, -0.33] : [-2.507, 1.969, -0.33]} rotation={last ? [0.908, 0.116, 0.855] : [-0.908, -0.116, -2.287]}>
            <mesh name="PART_R32-2210-BRACE_BAR_RIGHT" geometry={nodes['PART_R32-2210-BRACE_BAR_RIGHT'].geometry} >
              {metal}
            </mesh>
            <mesh name="32mm_Brace_Bracket" geometry={nodes['32mm_Brace_Bracket'].geometry} material={materials['Material_0.011']} position={[-0.028, -0.012, 0.016]} rotation={[1.417, 0.71, -0.807]}>
              {metal}
              {/* <mesh name="Mesh_1015" geometry={nodes.Mesh_1015.geometry}position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2013" geometry={nodes.Mesh_2013.geometry} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3013" geometry={nodes.Mesh_3013.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4013" geometry={nodes.Mesh_4013.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            <mesh name="32mm_Brace_Bracket001" geometry={nodes['32mm_Brace_Bracket001'].geometry} position={[0.027, 0.008, -2.493]} rotation={[1.847, 0.205, 2.136]}>
              {metal}
              {/* <mesh name="Mesh_1006_1" geometry={nodes.Mesh_1006_1.geometry} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_2006_1" geometry={nodes.Mesh_2006_1.geometry} position={[0.032, 0.013, 0.003]} rotation={[0, 0.052, -1.351]} >
                {metal}
              </mesh>
              <mesh name="Mesh_3006_1" geometry={nodes.Mesh_3006_1.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh>
              <mesh name="Mesh_4009_1" geometry={nodes.Mesh_4009_1.geometry} position={[0.029, 0.006, -0.007]} rotation={[Math.PI, -0.052, 2.979]} >
                {metal}
              </mesh> */}
            </mesh>
            {
              antiHotSpotTape &&
                <mesh name="ANTI-HOT-TAPE003" geometry={nodes['ANTI-HOT-TAPE003'].geometry} material={materials.tape} scale={1.001}/>
            }
          </group>
        </group>
        {
          zigzag &&
            <mesh name="2500_ZIGZAG" geometry={nodes['2500_ZIGZAG'].geometry} material={materials.zigzag} position={[4.024, 0, 0]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]} />
        }
      </group>
    )
  }
  if(!first && !last && cropSupportBar) {
    partsToShow.push(
      <group name="CROP-SUPPORT-BAR" key={`2500-crop-support-bar-${index}`} position={[-1.26, -0.003, -2.031]} rotation={[Math.PI, Math.PI / 2, 0]}>
        <mesh name="PART_25R32_CROP_SUPPORT_BAR" geometry={nodes.PART_25R32_CROP_SUPPORT_BAR.geometry} >
          {metal}
        </mesh>
        <group name="Brace_Bracket_R32_with_nut_and_bolt" position={[-0.059, 0.04, 0.726]} rotation={[Math.PI / 2, 0, -0.55]}>
          <group name="8mm_x_45mm_hex_bolt" position={[0.054, 0.025, 0.048]} rotation={[0, 0.052, -1.351]}>
            <mesh name="Mesh_1028" geometry={nodes.Mesh_1028.geometry} >
              {metal}
            </mesh>
            <mesh name="Mesh_2025" geometry={nodes.Mesh_2025.geometry}>
              {metal}
            </mesh>
          </group>
          <group name="M8_nut" position={[0.051, 0.018, 0.038]} rotation={[Math.PI, -0.052, 2.979]}>
            <mesh name="Mesh_3025" geometry={nodes.Mesh_3025.geometry}  >
              {metal}
            </mesh>
            <mesh name="Mesh_4025" geometry={nodes.Mesh_4025.geometry} >
              {metal}
            </mesh>
          </group>
          <mesh name="32mm_Brace_Bracket008" geometry={nodes['32mm_Brace_Bracket008'].geometry} position={[0.022, 0.012, 0.045]} >
            {metal}
          </mesh>
        </group>
        <group name="Brace_Bracket_R32_with_nut_and_bolt001" position={[-0.054, -0.048, -0.713]} rotation={[-Math.PI / 2, 0, -0.55]}>
          <group name="8mm_x_45mm_hex_bolt001" position={[0.054, 0.025, 0.048]} rotation={[0, 0.052, -1.351]}>
            <mesh name="Mesh_1014" geometry={nodes.Mesh_1014.geometry} >
              {metal}
            </mesh>
            <mesh name="Mesh_2015" geometry={nodes.Mesh_2015.geometry} >
              {metal}
            </mesh>
          </group>
          <group name="M8_nut017" position={[0.051, 0.018, 0.038]} rotation={[Math.PI, -0.052, 2.979]}>
            <mesh name="Mesh_3015" geometry={nodes.Mesh_3015.geometry} >
              {metal}
            </mesh>
            <mesh name="Mesh_4017" geometry={nodes.Mesh_4017.geometry} >
              {metal}
            </mesh>
          </group>
          <mesh name="32mm_Brace_Bracket009" geometry={nodes['32mm_Brace_Bracket009'].geometry} position={[0.022, 0.012, 0.045]} >
            {metal}
          </mesh>
        </group>
      </group>
    )
  }

  return partsToShow
}

export default ArchParts2500